import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, FormControl, RadioGroup,
  FormControlLabel, Radio, CircularProgress
} from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import Config from '../../ckcore/core/Config';
import User from '../../ckcore/core/User';
import { Roles, getRoleName, getRoleStatus } from '../../ckcore/core/Roles';
import TxStatus from '../../ckcore/core/TxStatuses';

export default function ChangeStaffStatusDialog({ open, onClose, partnerId, staff }) {
  const { keycloak } = useKeycloak();

  const initialEnabledValue = staff.enabled ?? true;
  const [enabled, setEnabled] = useState(initialEnabledValue);
  const [initialEnabled, setInitialEnabled] = useState(initialEnabledValue);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const enableSelectStatus = (statusId) => {
    // can not change owner
    if (staff.role === Roles.ADMIN && !User.isOwner()) {
      return false;
    }

    // can not disable my self
    if (staff.email === User.getEmail()) {
      return false;
    }

    // can not change waiting
    if (staff.statusId === TxStatus.WAITING || statusId === TxStatus.WAITING) {
      return false;
    }

    return true;
  }
  
  useEffect(() => {
    const initVal = staff.enabled ?? true;
    setEnabled(initVal);
    setInitialEnabled(initVal);
    setMessage({ type: '', text: '' });
  }, [staff]);

  const handleChangeStatus = async () => {
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const url = `${Config.getServerStaffURL()}/staff/${staff.id}/status`;
      const resp = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${keycloak.token}`
        },
        body: JSON.stringify({ enabled })
      });

      if (resp.ok) {
        setMessage({ type: 'success', text: enabled ? 'Mở khóa user thành công!' : 'Khóa user thành công!' });
        setTimeout(onClose, 1500);
      } else {
        const data = await resp.json();
        setMessage({ type: 'error', text: data.message || 'Lỗi khi cập nhật trạng thái' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Lỗi mạng hoặc server' });
    }
    setLoading(false);
    setInitialEnabled(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{'Cập nhật trạng thái'}</DialogTitle>
      <DialogContent dividers>
        {message.text && (
          <Typography color={message.type === 'error' ? 'error' : 'success.main'}>
            {message.text}
          </Typography>
        )}
        <Typography variant="subtitle1"><strong>Họ tên:</strong> {staff.name}</Typography>
        <Typography variant="subtitle1"><strong>Email:</strong> {staff.email}</Typography>

        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <RadioGroup
            row
            value={enabled ? 'enabled' : 'disabled'}
            onChange={(e) => setEnabled(e.target.value === 'enabled')}
          >
            <FormControlLabel
              control={<Radio color="primary" value="enabled" />}
              label={getRoleStatus(TxStatus.SUCCESS)}
              disabled={!enableSelectStatus(TxStatus.SUCCESS)}
            />
            <FormControlLabel
              control={<Radio color="primary" value="disabled" />}
              label={getRoleStatus(TxStatus.CANCEL)}
              disabled={!enableSelectStatus(TxStatus.CANCEL)}
            />
            <FormControlLabel
              control={<Radio color="primary" value="waiting" />}
              label={getRoleStatus(TxStatus.WAITING)}
              disabled={!enableSelectStatus(TxStatus.WAITING)}
            />            
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>Hủy</Button>
        <Button
          variant="outlined" color="warning"
          disabled={loading || enabled === initialEnabled}
          onClick={handleChangeStatus}
        >
          {loading && <CircularProgress size={16} color="inherit" />} Cập nhật
        </Button>
      </DialogActions>
    </Dialog>
  );
}
